export function isValidColor(value) {
  if (typeof value !== 'string') return false;
  const color = value.trim();
  if (!color) return false;

  if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
    return CSS.supports('color', color);
  }

  return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color);
}
